import { PaginationModule } from './../../shared/components/pagination/pagination.module';
import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';

import { CandidatsRoutingModule } from './candidats-routing.module';
import { CompareCandidatsComponent } from './components/compare-candidats/compare-candidats.component';
import { ResultsCompareComponent } from './components/results-compare/results-compare.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfilcandidatComponent } from './components/profilcandidat/profilcandidat.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ListCandidatsComponent } from './components/list-candidats/list-candidats.component';
import { RatingModule } from 'ngx-bootstrap/rating';
import { ContacterComponent } from './components/contacter/contacter/contacter.component';
import { CvCandidatComponent } from './components/cv-candidat/cv-candidat.component';
import { QuillModule } from 'ngx-quill';
import { CalendarModule } from 'primeng/calendar';
import localeFr from '@angular/common/locales/fr';
import {SharedModule} from 'app/shared/shared.module'
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SafeHtmlPipe } from './../../shared/pipes/safe-html.pipe';
const components = [
  ListCandidatsComponent,
  CompareCandidatsComponent,
  ResultsCompareComponent,
  ProfilcandidatComponent,
  ContacterComponent,
  CvCandidatComponent,
]
@NgModule({
  declarations: [
    SafeHtmlPipe,
    components
  ],
  imports: [
    CommonModule,
    CandidatsRoutingModule,
    FormsModule,
    NgSelectModule,
    PaginationModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    CalendarModule,
    SharedModule,
    MatMenuModule,
    MatTooltipModule,
    RatingModule.forRoot(),
    QuillModule.forRoot({
      modules: {
        syntax: true,
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'], // toggled buttons
          ['blockquote', 'code-block'],

          [{ header: 1 }, { header: 2 }], // custom button values
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
          [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
          [{ direction: 'rtl' }], // text direction

          [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
          [{ header: [1, 2, 3, 4, 5, 6, false] }],

          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ font: [] }],
          [{ align: [] }],

          ['clean'], // remove formatting button
        ],
      },
    }),
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'fr-FR' }]

})
export class CandidatsModule {
  constructor() {
    registerLocaleData(localeFr);
  }
}
